export default class Ingredient {
    constructor(id) {
        this.name = '';
        this.maxAmount = 0;
        this.productId = '';
        this.required = false;
        this.extraIngredients = [];
        this.localizedNames = [];
        this.selected = false;
        this.isEmpty = false;
        this.id = id;
    }
}
